const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js